function loadFile() {

    
}


export default loadFile

//Thank you stack overflow https://stackoverflow.com/a/21446426